import type { Layout } from "react-grid-layout";

import type { Pin, PinLayout } from "src/clients/analytics-dashboard";

export const GRID_COLUMNS = 6;
export const ROW_HEIGHT = 100;
export const GRID_GAP = 16;
export const GRID_MARGIN: [number, number] = [GRID_GAP, GRID_GAP];
export const GRID_CONTAINER_PADDING: [number, number] = [0, 0];

// Shared CSS-grid container styling for the non-RGL dashboard grids (static
// render + edit-mode background), kept in sync with the metrics above.
export const DASHBOARD_GRID_CLASS = "grid auto-rows-[100px] gap-4";
export const DASHBOARD_GRID_COLUMNS_STYLE = {
  gridTemplateColumns: `repeat(${GRID_COLUMNS}, minmax(0, 1fr))`,
} as const;

const MIN_WIDTH = 1;
const MIN_HEIGHT = 2;
const MAX_HEIGHT = 25;

export const pinsToLayout = (pins: Pin[]): Layout =>
  pins.map((pin) => ({
    i: pin.id,
    x: pin.layout.column - 1,
    y: pin.layout.row - 1,
    w: pin.layout.width,
    h: pin.layout.height,
    minW: MIN_WIDTH,
    maxW: GRID_COLUMNS,
    minH: MIN_HEIGHT,
    maxH: MAX_HEIGHT,
  }));

export const layoutToPinLayouts = (layout: Layout): Record<string, PinLayout> =>
  Object.fromEntries(
    layout.map((item) => [
      item.i,
      {
        column: item.x + 1,
        row: item.y + 1,
        width: item.w,
        height: item.h,
      },
    ]),
  );
